export const ADMIN_APP_NAME = "Sajt24.se";
export const ADMIN_APP_TITLE = `${ADMIN_APP_NAME} Admin`;
